<template>
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="运动项目名称" prop="exerciseName">
                  <a-input v-model="queryParam.exerciseName" placeholder="请输入运动项目名称" @pressEnter="handleQuery" allow-clear />
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :sm="24">
                <a-form-item label="课程姓名" prop="courseName">
                  <a-input v-model="queryParam.courseName" placeholder="请输入课程姓名" @pressEnter="handleQuery" allow-clear />
                </a-form-item>
              </a-col>

              <template v-if="advanced">
                <a-col :md="8" :sm="24">
                  <a-form-item label="购买人名称" prop="nickname">
                    <a-input v-model="queryParam.nickname" placeholder="请输入购买人名称" @pressEnter="handleQuery" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="购买人手机号" prop="mobile">
                    <a-input v-model="queryParam.mobile" placeholder="购买人手机号" @pressEnter="handleQuery" allow-clear />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="支付方式" prop="payType">
                    <a-select v-model="queryParam.payMethod">
                      <a-select-option :value="1">积分兑换</a-select-option>
                      <a-select-option :value="2">现金交易</a-select-option>
                      <a-select-option :value="3">积分加现金</a-select-option>
                      <a-select-option :value="4">现金加现金券</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="订单状态" prop="status">
                    <a-select v-model="queryParam.status">
                      <a-select-option :value="-1">已取消</a-select-option>
                      <a-select-option :value="0">待支付</a-select-option>
                      <a-select-option :value="1">已支付</a-select-option>
                      <a-select-option :value="2">已发货</a-select-option>
                      <a-select-option :value="3">已完成</a-select-option>
                      <a-select-option :value="4">售后中</a-select-option>
                      <a-select-option :value="5">待评价</a-select-option>
                      <a-select-option :value="6">已收货</a-select-option>
                      <a-select-option :value="7">售后完成</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col> -->
                 <a-col :md="8" :sm="24">
                   <a-form-item label="时间">
                     <a-range-picker style="width: 100%" v-model="dateRange" valueFormat="YYYY-MM-DD" format="YYYY-MM-DD"
                       allow-clear />
                   </a-form-item>
                 </a-col>
              <!-- </template> -->
              <a-col :md="!advanced && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a> -->
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <!-- <div class="table-operations"> -->
          <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:order:add']">-->
          <!--          <a-icon type="plus" />新增-->
          <!--        </a-button>-->
          <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['order:order:edit']">-->
          <!--          <a-icon type="edit" />修改-->
          <!--        </a-button>-->
          <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:order:remove']">-->
          <!--          <a-icon type="delete" />删除-->
          <!--        </a-button>-->
          <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['order:order:export']">-->
          <!--          <a-icon type="download" />导出-->
          <!--        </a-button>-->
          <!-- <table-setting :style="{float: 'right'}" :table-size.sync="tableSize" v-model="columns"
            :refresh-loading="loading" @refresh="getList" />
        </div> -->
        <!-- 增加修改 -->
        <!-- <create-form ref="createForm" @ok="getList" /> -->
        <!-- 数据展示 -->
        <a-table :loading="loading" :size="tableSize" rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}" :columns="columns" :data-source="list"
          :pagination="false" :bordered="tableBordered">
          <span slot="index" slot-scope="text, record,index">
            {{(current-1)*size+index+1}}
          </span>
          <span slot="image" slot-scope="text, record">
          <img
            v-viewer
            style="width: 48px; height: 48px; margin-top: 5px; margin-right: 5px"
            v-if="record.picture"
            :src="record.picture"
            preview="头像"
          />
        </span>
          <span slot="payTime" slot-scope="text, record">
            {{ parseTime(record.payTime) }}
          </span>
          <span slot="createTime" slot-scope="text, record">
            {{ parseTime(record.createTime) }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <!--          <a-divider type="vertical" v-hasPermi="['order:order:edit']" />-->
            <a @click="$refs.OrderCreateForm.handleUpdate(record, undefined)" v-hasPermi="['order:order:edit']">
              <a-icon type="file" />查看详情
            </a>
            <!--          <a-divider type="vertical" v-hasPermi="['order:order:remove']" />-->
            <!--          <a @click="handleDelete(record)" v-hasPermi="['order:order:remove']">-->
            <!--            <a-icon type="delete" />删除-->
            <!--          </a>-->
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
          :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange" @change="changeSize" />
      </a-card>
    </page-header-wrapper>
  </template>

  <script>
    // import {
    //   pageOrderOrder,
    //   listOrderOrder,
    //   delOrderOrder
    // } from '@/api/order/orderOrder'
    import OrderCreateForm from './modules/OrderCreateForm'
    import {pageRecord} from '@/api/user/report'
    import {
      tableMixin
    } from '@/store/table-mixin'

    export default {
      name: 'OrderOrder',
      components: {
        OrderCreateForm
      },
      props:["type"],
      mixins: [tableMixin],
      data() {
        return {
          list: [],
          selectedRowKeys: [],
          selectedRows: [],
          // 高级搜索 展开/关闭
          advanced: false,
          // 非单个禁用
          single: true,
          // 非多个禁用
          multiple: true,
          ids: [],
          loading: false,
          total: 0,
          current: 0,
          size: 0,
          dateRange: [],
          // 查询参数
          queryParam: {
            // 时间访问查询

            exerciseName: '',
        exerciseId: null,
        exerciseTime: null,
        id: null,
        kilocalorie: null,
        sortField: '',
        sortOrder: '',
        userId: null,
        createBeginTime: '',
        createEndTime: '',
            pageNum: 1,
            pageSize: 10
          },
          columns: [{
              title: '序号',
              dataIndex: 'index',
              key: 'index',
              align: 'center',
              width: 50,
              fixed: 'left',
              scopedSlots: {
                customRender: 'index'
              },
            },
            // {
            //   title: '课程名称',
            //   dataIndex: 'courseName',
            //   ellipsis: true,
            //   align: 'center'
            // },
            {
              title: '运动项目名称',
              dataIndex: 'exerciseName',
              ellipsis: true,
              align: 'center'
            },
            {
              title: '消耗热量 千卡',
              dataIndex: 'kilocalorie',
              ellipsis: true,
              align: 'center'
            },
          //   {
          //     title: '运动图片',
          //     dataIndex: 'picture',
          //     ellipsis: true,
          // scopedSlots: { customRender: 'image' },
          // align: 'center',
          // width: 100,
          //   },

            {
              title: '运动时长',
              dataIndex: 'exerciseTime',
              ellipsis: true,
              align: 'center'
            },

            // {
            //   title: '时间',
            //   dataIndex: 'payTime',
            //   scopedSlots: {
            //     customRender: 'payTime'
            //   },
            //   ellipsis: true,
            //   align: 'center',
            //   width:180
            // },
            // {
            //   title: '消耗积分数',
            //   dataIndex: 'reduceScores',
            //   ellipsis: true,
            //   align: 'center'
            // },
            // {
            //   title: '消耗现金券额度',
            //   dataIndex: 'reduceVoucher',
            //   ellipsis: true,
            //   align: 'center'
            // },
            // {
            //   title: '运费',
            //   dataIndex: 'freightAmount',
            //   ellipsis: true,
            //   align: 'center'
            // },

            {
              title: '备注',
              dataIndex: 'remark',
              ellipsis: true,
              align: 'center'
            },
            // {
            //   title: '操作',
            //   dataIndex: 'operation',
            //   width: '18%',
            //   scopedSlots: { customRender: 'operation' },
            //   align: 'center'
            // }
          ]
        }
      },
      filters: {},
      activated() {
        if(this.type!='tk'){
          this.getList()
        }
    },
      computed: {},
      watch: {},
      methods: {
        goList(record, type) {
        var this_ = this
        this_.$nextTick(() => {
          this_.queryParam.userId = record.id
          // this_.queryParam.type = type
          this_.list = []
          this_.total = 0
          this_.current = 0
          this_.size = 0
          this_.getList()//这是我自定义的
        })
      },
        /** 查询订单信息列表 */
        getList() {
          this.loading = true
          if(this.dateRange !== null && this.dateRange !== '' && this.dateRange.length === 2) {
        this.queryParam.createBeginTime = this.dateRange[0] +" 00:00:00"
        this.queryParam.createEndTime = this.dateRange[1]+" 23:59:59"
      }else {
        this.queryParam.createBeginTime = null
        this.queryParam.createEndTime = null
      }
          pageRecord(this.queryParam).then(response => {
            this.list = response.data.records
            this.total = response.data.total
            this.current = response.data.current
            this.size = response.data.size
            this.loading = false
          })
        },

        /** 搜索按钮操作 */
        handleQuery() {
          this.queryParam.pageNum = 1
          this.queryParam.type = 4
          this.getList()
        },
        /** 重置按钮操作 */
        resetQuery() {
          this.queryParam = {

            exerciseName: '',
        exerciseId: null,
        exerciseTime: null,
        id: null,
        kilocalorie: null,
        sortField: '',
        sortOrder: '',
        createBeginTime: '',
        createEndTime: '',
            pageNum: 1,
            pageSize: 10
          }
          this.dateRange=[]
          this.handleQuery()
        },
        onShowSizeChange(current, pageSize) {
          this.queryParam.pageSize = pageSize
          this.getList()
        },
        changeSize(current, pageSize) {
          this.queryParam.pageNum = current
          this.queryParam.pageSize = pageSize
          this.getList()
        },
        onSelectChange(selectedRowKeys, selectedRows) {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
          this.ids = this.selectedRows.map(item => item.id)
          this.single = selectedRowKeys.length !== 1
          this.multiple = !selectedRowKeys.length
        },
        toggleAdvanced() {
          this.advanced = !this.advanced
        },
        /** 删除按钮操作 */
        handleDelete(row) {
          var that = this
          const ids = row.id || this.ids
          if (row.id) {
            this.ids.push(row.id)
          }
          this.$confirm({
            title: '确认删除所选中数据?',
            content: '当前选中编号为' + ids + '的数据',
            onOk() {
              let data = []
              that.ids.map(id => data.push({
                "id": id
              }))
              return delOrderOrder(data)
                .then(() => {
                  that.onSelectChange([], [])
                  that.getList()
                  that.$message.success(
                    '删除成功',
                    3
                  )
                })
            },
            onCancel() {
              //取消清空删除ids列表
              that.ids = []
            }
          })
        },
        /** 导出按钮操作 */
        handleExport() {
          var that = this
          this.$confirm({
            title: '是否确认导出?',
            content: '此操作将导出当前条件下所有数据而非选中数据',
            onOk() {
              that.download('order/order/export', {
                ...that.queryParam
              }, `订单信息_${new Date().getTime()}.xlsx`)
            },
            onCancel() {}
          })
        }
      }
    }
  </script>